var _rect, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _path14, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 51,
    viewBox: "0 0 778 285",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 222,
    y: 200,
    width: 13,
    height: 2,
    fill: "#2EB67D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.802 152.175C221.802 168.337 208.699 181.44 192.537 181.44C176.374 181.44 163.272 168.337 163.272 152.175C163.272 136.012 176.374 122.909 192.537 122.909C208.699 122.909 221.802 136.012 221.802 152.175Z",
    fill: "#1986F0",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.503 142.706C184.503 166 165.749 184.883 142.614 184.883C119.479 184.883 100.725 166 100.725 142.706C100.725 119.413 119.479 100.53 142.614 100.53C165.749 100.53 184.503 119.413 184.503 142.706Z",
    fill: "#27D7FE",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 82.2685C64 60.0288 81.7313 42 103.604 42L224.396 42C246.269 42 264 60.0288 264 82.2684L264 201.732C264 223.971 246.269 242 224.396 242L103.604 242C81.7313 242 64 223.971 64 201.732L64 82.2685Z",
    fill: "white",
    fillOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.556 165.11C116.113 160.667 116.113 153.463 120.556 149.02L165.217 104.359C169.66 99.9164 176.864 99.9164 181.307 104.359V104.359C185.75 108.802 185.75 116.006 181.307 120.449L136.646 165.11C132.203 169.553 124.999 169.553 120.556 165.11V165.11Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.947 147.411L163.608 102.75C168.94 97.4188 177.584 97.4188 182.916 102.75C188.248 108.082 188.248 116.726 182.916 122.058L138.255 166.719C132.923 172.051 124.279 172.051 118.947 166.719C113.616 161.387 113.616 152.743 118.947 147.411ZM120.556 149.02C116.113 153.463 116.113 160.667 120.556 165.11C124.999 169.553 132.203 169.553 136.646 165.11L181.307 120.449C185.75 116.006 185.75 108.802 181.307 104.359C176.864 99.9164 169.66 99.9164 165.217 104.359L120.556 149.02Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.474 199.472C159.917 203.915 167.12 203.915 171.563 199.472L228.959 142.076L220.234 118.621L155.474 183.382C151.031 187.825 151.031 195.029 155.474 199.472V199.472Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.601 142.651L221.131 114.506L153.865 181.773C148.533 187.104 148.533 195.749 153.865 201.08C159.196 206.412 167.841 206.412 173.172 201.08L231.601 142.651ZM155.474 183.382C151.031 187.825 151.031 195.028 155.474 199.471C159.917 203.914 167.12 203.914 171.563 199.471L228.959 142.076L220.234 118.621L155.474 183.382Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.297 199.737C166.854 204.18 159.651 204.18 155.208 199.737L97.8117 142.341L106.537 118.887L171.297 183.648C175.74 188.091 175.74 195.294 171.297 199.737V199.737Z",
    fill: "url(#paint4_linear_0_1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1697 142.917L105.64 114.772L172.906 182.039C178.238 187.37 178.238 196.015 172.906 201.346C167.574 206.678 158.93 206.678 153.599 201.346L95.1697 142.917ZM171.297 183.648C175.74 188.091 175.74 195.294 171.297 199.737C166.854 204.18 159.651 204.18 155.208 199.737L97.8116 142.341L106.537 118.887L171.297 183.648Z",
    fill: "url(#paint5_linear_0_1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.887 131.329C101.615 138.602 101.701 144.793 104.123 148.653L98.0896 142.619C89.2036 133.733 89.2022 119.327 98.0883 110.441L125.01 83.5192C125.01 83.5192 142.502 97.7149 130.246 109.971L108.887 131.329Z",
    fill: "url(#paint6_linear_0_1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.325 165.709C209.768 161.266 209.768 154.063 205.325 149.62L139.968 84.2625C135.525 79.8194 128.322 79.8194 123.879 84.2624V84.2624C119.436 88.7055 119.436 95.909 123.879 100.352L189.236 165.709C193.679 170.152 200.882 170.152 205.325 165.709V165.709Z",
    fill: "url(#paint7_linear_0_1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.934 148.011L141.577 82.6537C136.245 77.3221 127.601 77.3221 122.269 82.6537C116.938 87.9854 116.938 96.6296 122.269 101.961L187.627 167.318C192.958 172.65 201.602 172.65 206.934 167.318C212.266 161.987 212.266 153.343 206.934 148.011ZM205.325 149.62C209.768 154.063 209.768 161.266 205.325 165.709C200.882 170.152 193.679 170.152 189.236 165.709L123.878 100.352C119.435 95.9093 119.435 88.7057 123.878 84.2627C128.321 79.8197 135.525 79.8197 139.968 84.2627L205.325 149.62Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M181.142 120.836L165.053 104.747L187.16 82.6398C191.603 78.1968 198.806 78.1968 203.249 82.6398C203.364 82.7544 203.475 82.871 203.584 82.9892C203.702 83.0972 203.818 83.2082 203.931 83.3221L229.816 109.206C238.702 118.092 238.7 132.498 229.814 141.384L223.781 147.418C226.203 143.558 226.289 137.367 219.016 130.094L195.45 106.528L181.142 120.836Z",
    fill: "url(#paint8_linear_0_1)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M235.667 178.25C258.334 178.25 261.639 164.758 264 157V208C264 226.778 248.778 242 230 242H179C189.794 240.651 206.254 230.586 203.96 211.643C201.667 192.7 213 178.25 235.667 178.25Z",
    fill: "#2EB67D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M237.842 192L246.526 200.684V210.532C245.102 208.761 242.896 207.632 240.447 207.632C236.869 207.632 233.865 210.028 232.927 213.294C230.721 214.197 229.158 216.385 229.158 218.921C229.158 220.623 229.853 222.169 230.982 223.263H222.211C219.327 223.263 217 220.936 217 218.053V197.211C217 194.327 219.327 192 222.211 192H237.842ZM240.447 209.368C243.539 209.368 246.092 211.678 246.474 214.648C248.489 215.031 250 216.802 250 218.921C250 221.318 248.055 223.263 245.658 223.263H235.237C232.84 223.263 230.895 221.318 230.895 218.921C230.895 216.802 232.406 215.031 234.421 214.648C234.803 211.678 237.356 209.368 240.447 209.368Z",
    fill: "#F9FDFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223 201H241V203H223V201Z",
    fill: "#2EB67D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 208,
    width: 8,
    height: 2,
    fill: "#2EB67D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292 185.947H309.073V153.399L350.138 153.399V139.082L309.073 139.082V118.062C309.073 116.411 310.411 115.073 312.062 115.073L356.651 115.073V98H302.961C296.908 98 292 102.908 292 108.961V185.947ZM448.841 98H431.94V186H448.841V98ZM424.504 158.803H374.523C376.875 166.385 383.945 171.891 392.298 171.891C398.171 171.891 403.407 169.171 406.819 164.919L407.515 164.052L418.243 174.781L417.539 175.485C411.082 181.948 402.156 185.947 392.298 185.947C375.534 185.947 361.472 174.387 357.646 158.803H357.587L357.437 157.987C357.407 157.821 357.378 157.655 357.35 157.488C357.075 156.151 356.998 155.257 356.886 153.95L356.878 153.858C356.841 153.434 356.854 152.859 356.865 152.361C356.87 152.146 356.874 151.944 356.874 151.775C356.874 132.903 372.173 117.603 391.046 117.603C409.918 117.603 425.218 132.903 425.218 151.775C425.218 153.896 425.024 155.972 424.654 157.987L424.504 158.803ZM407.672 144.747C405.867 137.239 399.107 131.66 391.046 131.66C382.985 131.66 376.225 137.239 374.42 144.747H407.672ZM490.01 185.947C508.883 185.947 524.182 170.648 524.182 151.775C524.182 132.903 508.883 117.603 490.01 117.603C471.138 117.603 455.839 132.903 455.839 151.775C455.839 170.648 471.138 185.947 490.01 185.947ZM507.109 151.775C507.109 163.034 499.315 171.89 490.01 171.89C480.705 171.89 472.911 163.034 472.911 151.775C472.911 140.516 480.705 131.66 490.01 131.66C499.315 131.66 507.109 140.516 507.109 151.775ZM553 98H583.953C608.279 98 628 117.721 628 142.047C628 166.374 608.279 186.094 583.953 186.094H553V98ZM570.353 111.765H579.365C596.089 111.765 609.647 125.323 609.647 142.047C609.647 158.772 596.089 172.329 579.365 172.329H570.353V111.765ZM745.988 117C759.608 117 771.376 124.936 776.918 136.436L761.946 143.834C759.399 136.323 753.137 131.116 745.988 131.116C736.643 131.116 728.816 140.009 728.816 151.316C728.816 162.622 736.643 171.516 745.988 171.516C753.461 171.516 759.965 165.826 762.269 157.763L777.25 165.487C771.856 177.368 759.887 185.632 745.988 185.632C727.035 185.632 711.672 170.268 711.672 151.316C711.672 132.364 727.035 117 745.988 117ZM704.344 152.172C704.344 171.044 689.044 186.344 670.172 186.344C651.299 186.344 636 171.044 636 152.172C636 133.299 651.299 118 670.172 118C689.044 118 704.344 133.299 704.344 152.172ZM670.172 172.287C679.477 172.287 687.271 163.431 687.271 152.172C687.271 140.913 679.477 132.057 670.172 132.057C660.867 132.057 653.073 140.913 653.073 152.172C653.073 163.431 660.867 172.287 670.172 172.287Z",
    fill: "#0A2D53"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1",
    x: 63.2717,
    y: 22.9094,
    width: 258.53,
    height: 258.53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_1",
    x: 0.724854,
    y: 0.530273,
    width: 283.779,
    height: 284.352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_0_1",
    x: 44,
    y: 22,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.527396 0 0 0 0 0.593104 0 0 0 0 0.691667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 128.153,
    y1: 149.79,
    x2: 171.308,
    y2: 103.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 142.353,
    y1: 162.724,
    x2: 187.884,
    y2: 112.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 173.067,
    y1: 189.601,
    x2: 228.371,
    y2: 138.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 160.634,
    y1: 174.901,
    x2: 221.824,
    y2: 120.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 153.704,
    y1: 189.867,
    x2: 98.3998,
    y2: 138.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 166.137,
    y1: 175.167,
    x2: 104.946,
    y2: 121.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.608525,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 95.878,
    y1: 124.156,
    x2: 126.976,
    y2: 92.0552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_0_1",
    x1: 193.825,
    y1: 146.486,
    x2: 136.637,
    y2: 84.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273DFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_0_1",
    x1: 224.82,
    y1: 141.517,
    x2: 158.818,
    y2: 100.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182306,
    stopColor: "#1D94F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907412,
    stopColor: "#273DFE"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.2286816b.svg";
export { ForwardRef as ReactComponent };